import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "inquiry end"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<h2>お問合せ</h2><div class=\"inner\"><ul class=\"step_3\"><li class=\"off2\">入力</li><li class=\"off2\">確認</li><li class=\"active\">完了<i class=\"fas fa-caret-up step-triangle\"></i></li></ul><p> お問合せを承りました。<br class=\"sp\">回答までしばらくお待ちください。<br> １週間たっても返事が無い場合は、正しく受信できなかった可能性がありますので、<br class=\"pc\"> 恐れ入りますが再度のご連絡をお願い致します。 </p></div>", 2);
const _hoisted_6 = { class: "bt_home" };
import { computed } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'inquiry_end',
    props: {
        common: null
    },
    setup(__props) {
        const props = __props;
        const switchHome = computed(() => {
            return props.common.role ? route('question.index') : route('home');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(Link), {
                                    href: _unref(switchHome),
                                    class: "bt_home"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("ホームに戻る")
                                    ]),
                                    _: 1
                                }, 8, ["href"])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
